// extracted by mini-css-extract-plugin
export var loadingSpinner = "_3o-1";
export var standaloneTable = "_3o-0";